/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Builder_Prop_ColorInputs */

const cs_builder_prop_color = /** @type {(inputs: Builder_Prop_ColorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Barva`)
};

const en_builder_prop_color = /** @type {(inputs: Builder_Prop_ColorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Color`)
};

/**
* | output |
* | --- |
* | "Color" |
*
* @param {Builder_Prop_ColorInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const builder_prop_color = /** @type {((inputs?: Builder_Prop_ColorInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Builder_Prop_ColorInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_builder_prop_color(inputs)
	return cs_builder_prop_color(inputs)
});